import ivclass from '@invideoio/web-shared/Modules/IVClass';

import { AuthorDetailsType } from 'src/types';

import ImageComponent from '@components/common/ImageComponent/ImageComponent';
import UserSocialIcons from '@components/user-social-icons';
import { getWebpURL } from '@utils/common.utils';
import { PlatformType } from '@invideoio/web-shared/constants/common';
import { BrowserType, DEFAULT_LOGO_URL } from '@constants/common';

interface AuthorHeaderSectionProps extends AuthorDetailsType {
  pathName: string;
  platform: PlatformType;
  browser: BrowserType;
}

const AuthorHeaderSection = ({
  avatar,
  name,
  pathName,
  platform,
  browser,
  authorDescription,
  authorSocialLinks,
}: AuthorHeaderSectionProps) => {
  const avatarUrl =
    browser !== BrowserType.Safari && avatar?.url
      ? getWebpURL(avatar?.url, platform)
      : avatar?.url || DEFAULT_LOGO_URL;
  return (
    <section
      className={ivclass(
        'iv-mt-[65px] md:iv-mt-[70px] sm:iv-mt-50',
        'iv-mb-100 md:iv-mb-20 sm:iv-mb-20',
      )}
    >
      <div className={ivclass('iv-container iv-mx-auto')}>
        <div className={ivclass('iv-grid iv-grid-cols-12')}>
          <div
            className={ivclass(
              'iv-col-start-2 iv-col-span-7',
              'md:iv-col-start-1 md:iv-col-span-12',
              'sm:iv-col-start-1 sm:iv-col-span-12',
            )}
          >
            <h1
              className={ivclass(
                'iv-text-heading-4xl md:iv-text-heading-3xl sm:iv-text-heading-m',
                'iv-font-extrabold',
                'iv-text-black-90',
                'iv-max-w-[800px] md:iv-max-w-full',
                'iv-px-15 lg:iv-px-[37px] md:iv-px-20',
                'iv-mb-[18px] md:iv-mb-[27px] sm:iv-mb-30',
                'iv-mt-[64px] md:iv-mt-[0] sm:iv-mt-[0]',
                'sm:iv-text-center',
              )}
            >
              {name}
            </h1>
            <div
              className={ivclass(
                'iv-text-heading-2xs sm:iv-text-body-3xl iv-font-semibold',
                'iv-text-black-50',
                'iv-px-[18px] lg:iv-px-[37px] md:iv-px-25 sm:iv-px-35',
                'iv-mb-[63px] md:iv-mb-40 sm:iv-mb-25',
                'iv-leading-[36px]',
                'sm:iv-text-center',
              )}
            >
              {authorDescription}
            </div>
            <div
              className={ivclass(
                'iv-flex sm:iv-justify-center',
                'iv-gap-8',
                'iv-px-20 lg:iv-px-[37px] md:iv-px-25',
                'sm:iv-mb-25',
              )}
            >
              {authorSocialLinks && (
                <UserSocialIcons socialLinks={authorSocialLinks} />
              )}
            </div>
          </div>
          <div
            className={ivclass(
              'iv-col-span-4 md:iv-col-span-12 sm:iv-col-span-12',
              'md:iv-flex md:iv-justify-center',
              'sm:iv-flex sm:iv-justify-center',
            )}
          >
            <ImageComponent
              elementype={avatar?.url ? 'imagekit' : 'native'}
              loading="lazy"
              src={avatarUrl || ''}
              className={ivclass(
                'iv-w-[400px] iv-h-[400px]',
                'sm:iv-w-[240px] sm:iv-h-[240px]',
                'iv-ml-[-10px] lg:iv-ml-[-45px]',
                'sm:iv-mx-auto',
                'iv-rounded-full',
              )}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AuthorHeaderSection;
